const searchProcessing = (searchContainer) => {

    const
        input = searchContainer.querySelector('[data-role="query"]'),
        icon = searchContainer.querySelector('[data-role="icon-search"]'),
        defaultPosts = document.getElementById('default-posts'),
        results = document.getElementById('search-result'),
        skeleton = document.getElementById('search-result-skeleton');

    let
        timeoutInput = null,
        request = null;
    input.addEventListener('input', () => {

        if (input.value.trim().length == 0) {

            defaultPosts.classList.remove('hidden');
            results.innerHTML = '';

            if (timeoutInput) {

                clearTimeout(timeoutInput);
                timeoutInput = null;
            }

            return;
        }

        if (!defaultPosts.classList.contains('hidden'))
            defaultPosts.classList.add('hidden');

        if (timeoutInput) {

            // already typing

            clearTimeout(timeoutInput);
            timeoutInput = null;
        }
        else {

            // start search

            icon.setAttribute('data-loading', '');

            results.innerHTML = '';
            results.appendChild(skeleton.content.cloneNode(true));
        }

        if (request)
            request.abort();
        // request already started

        timeoutInput = setTimeout(() => {

            const formData = new FormData();
            // eslint-disable-next-line no-undef
            formData.append('nonce', ajax.nonce);
            formData.append('action', 'caranga_search');
            formData.append('text', input.value);

            const options = {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
            };

            // eslint-disable-next-line no-undef
            request = fetch(ajax.url, options)
                .then((response) => response.text())
                .then((response) => {

                    icon.removeAttribute('data-loading');

                    results.innerHTML = response;
                    document.dispatchEvent(new CustomEvent('DOMContentUpdated', { detail: { target: results, isSearch: true } }));
                    request = null;
                });

            timeoutInput = null;
        }, 1 * 1000);
    });
};

document
    .querySelectorAll('[data-toggle="search"')
    .forEach((toggler) => {

        const
            searchContainer = toggler.closest('[data-role="search-container"]'),
            wrapper = searchContainer.querySelector('[data-role="wrapper"]'),
            input = searchContainer.querySelector('[data-role="query"]'),
            title = searchContainer.querySelector('[data-role="title"]'),
            close = searchContainer.querySelector('[data-role="close"]'),
            inputWrapper = searchContainer.querySelector('[data-role="input-wrapper"]'),
            titleWidth = title.getBoundingClientRect().width + /* gap */ 8,
            showSearch = () => {

                wrapper.style.setProperty('transform', `translateX(-${titleWidth}px)`);
                inputWrapper.classList.remove('invisible');
            },
            clearSearch = () => {

                input.value = '';
                input.dispatchEvent(new Event('input'));
            };

        /** visual */
        wrapper.style.setProperty('width', `calc(100% + ${titleWidth}px`);

        toggler.addEventListener('click', showSearch);
        close.addEventListener('click', clearSearch);

        /** processing */
        searchProcessing(searchContainer);
    });